import { Component,OnInit,OnDestroy,AfterViewInit,Input } from "@angular/core";
import { NgbModal,NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { takeWhile } from "rxjs/operators";

import {
    FvmsCommonService
    ,FvmsApiNoticeService
    ,FvmsApiAuthService
} from "src/app/shared/service";
import {
    DtgActionType
} from "src/app/shared/vo";

@Component({
    templateUrl: "./dtg.notice.form.component.html"
    ,providers: []
})
export class DtgNoticeFormComponent implements OnInit,OnDestroy,AfterViewInit {
    isContinue:boolean = true;
    @Input() noticeId:string;
    @Input() noticeInfo:any;
    @Input() dtgActionType:DtgActionType;
    readOnly:boolean = true;
    DtgActionType = DtgActionType;
    listNotice:any;
    currentUserInfo:any;
    userGroupId:number = 99999;
    
    constructor(
        private modalService: NgbModal
        ,public activeModal: NgbActiveModal
        ,private fvmsApiNoticeService:FvmsApiNoticeService
        ,private fvmsApiAuthService:FvmsApiAuthService
    ) {
        this.currentUserInfo = this.fvmsApiAuthService.getLoginUserInfo();
        if(this.currentUserInfo){
            this.userGroupId = parseInt(this.currentUserInfo.userGroupId);
        }
     }

    ngOnInit() {
        switch(this.dtgActionType){
            case DtgActionType.create:
                this.readOnly = false;
                break;
            case DtgActionType.update:
            case DtgActionType.delete:
                this.readOnly = false;
                break;
            case DtgActionType.read:
            default:
                this.readOnly = true;
                break;
        }
        this.updateViewCount();
    }

    ngOnDestroy() {
        this.isContinue = false;
    }
    
    ngAfterViewInit() {
        
    }

    parseContent(content){
        return decodeURIComponent(content);
    }

    updateViewCount(){
        this.fvmsApiNoticeService.updateViewCount(this.noticeInfo.noticeId)
            .pipe(takeWhile(() => this.isContinue))
            .subscribe(response => {
                // console.log("updateViewCount",response);
            });
    }

    clickCancel(){
        this.activeModal.close({
            "result":"cancel"
        });
    }
}